export const STANDARD_MAX_INPUT = 10000
export const PREMIUM_MAX_INPUT = 30000

export default {
    STANDARD_MAX_INPUT,
    PREMIUM_MAX_INPUT
}